export const BIOMETRICS_LOGIN = 'BIOMETRICS_LOGIN'
export const BIOMETRICS_SUCCESS = 'BIOMETRICS_SUCCESS'
export const BIOMETRICS_ERROR = 'BIOMETRICS_ERROR'
export const BIOMETRICS_ENABLE = 'BIOMETRICS_ENABLE'
export const BIOMETRICS_DISABLE = 'BIOMETRICS_DISABLE'
export const BIOMETRICS_ENABLE_LOADING = 'BIOMETRICS_ENABLE_LOADING'
export const BIOMETRICS_DISABLE_LOADING = 'BIOMETRICS_DISABLE_LOADING'
